import { DossierDetailsContent, DossierDetailsHeader, DossierDetailsPanel } from "@/app/pages/dossier/dossier-details-panel";
import { useDossierId } from "@/features/dossier-details";
import { OpstartplanDetails } from "@/features/opstartplan";
import { VsmDetails } from "@/features/vsm";
import { Separator } from "@/shared/components";

export function VsmOpstartplanDetails() {
    const id = useDossierId();

    return (
        <DossierDetailsPanel>
            <DossierDetailsHeader section="VsmOfOpstartplan" showBackButton showBerichtBalk />
            <DossierDetailsContent className="flex flex-col gap-4">
                <OpstartplanDetails dossierNummer={id} />
                <Separator orientation="horizontal" />
                <VsmDetails dossierNummer={id} />
            </DossierDetailsContent>
        </DossierDetailsPanel>
    );
}
